import React, { FunctionComponent, useEffect, useState } from 'react';

import classnames from 'classnames';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useJobs } from 'common/jobs/Jobs';

import 'common/jobs/jobs-notifier/JobsNotifier.scss';

export const JobsNotifier: FunctionComponent = () => {
    const { t } = useTranslation(['common/jobs']);

    const [show, setShow] = useState<boolean>(false);
    const [multiple, setMultiple] = useState<boolean>(false);
    const [{ runningJobs }, jobsDispatch] = useJobs();

    const footerClassnames = classnames('job-actions modal-footer', {
        multiple,
    });

    const batch = (jobId: string): void => {
        jobsDispatch.batchJob(jobId);
    };

    const wait = (jobId: string): void => {
        jobsDispatch.waitJob(jobId);
    };

    useEffect(() => {
        const count = Object.values(runningJobs).filter((runningJob) => runningJob.showNotification).length;

        if (count > 0) {
            setShow(true);
        } else {
            setShow(false);
        }

        if (count > 1) {
            setMultiple(true);
        } else {
            setMultiple(false);
        }
    }, [runningJobs, setShow, setMultiple]);

    if (show) {
        return (
            <div className="r4e-jobs-notifier modal-dialog">
                <div className="modal-content">
                    <div className="modal-body">
                        <h4>{multiple ? t('JOB_NOTIFICATION_MULTIPLE_TITLE') : t('JOB_NOTIFICATION_SINGLE_TITLE')}</h4>
                        <h6>
                            {multiple ? t('JOB_NOTIFICATION_MULTIPLE_MESSAGE') : t('JOB_NOTIFICATION_SINGLE_MESSAGE')}
                        </h6>

                        <ul className={footerClassnames}>
                            {Object.values(runningJobs)
                                .filter((runningJob) => runningJob.showNotification)
                                .map((runningJob) => {
                                    return (
                                        <li key={runningJob.jobId}>
                                            {multiple ? <span className="job-name">{runningJob.name}</span> : null}
                                            <Button
                                                variant="primary"
                                                onClick={(): void => {
                                                    batch(runningJob.jobId);
                                                }}
                                            >
                                                {t('JOB_BATCH')}
                                            </Button>
                                            <Button
                                                variant="default"
                                                onClick={(): void => {
                                                    wait(runningJob.jobId);
                                                }}
                                            >
                                                {t('JOB_WAIT')}
                                            </Button>
                                        </li>
                                    );
                                })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};
